<template>
	
	<BarArrowButton class="bar" :flex="true" :large="true" title="Your Daily News" href="/#/PersonalNews">
		<div class="barArrowButtonSlotContent">
			<a href="/#/PersonalNews">
			<p>Your personalised, friendly, finance-flavoured news catch-up!</p>
			<div class="centered" style="font-size: 50px; padding-top: 0px; margin-top: -10px; color: var(--background-color-alt6)">
				<v-icon icon="mdi-newspaper-variant" />
			</div>
			</a>
		</div>
	</BarArrowButton>
	
</template>

<script>
import BarArrowButton from './BarArrowButton.vue';

export default {
	name: "NewsShoutPanel",
	props: [],
	components: {
		BarArrowButton
	},
	data() {
		return{
			something: null
		}
	},
	methods: {
		onLoad() {
		}
	},
	mounted: function() { this.onLoad(); }
}
</script>

<style scoped>

.bar {
	c--olor: white;
}

.barArrowButtonSlotContent {
	padding: 20px;
	padding-top: 12px;
	padding-bottom: 5px;
	p {
		margin-top: -5px;
		font-size: 13px;
	}
	c--olor: white;
}


</style>